import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import Formulario from './components/Formulario';
import AdminLogin from './components/admin/AdminLogin';
import GerenciamentoColonia from './components/admin/GerenciamentoColonia';
import RelatoriosColonia from './components/admin/RelatoriosColonia';
import ChamadaRapida from './components/admin/ChamadaRapida';
import CadastrosTemporarios from './components/admin/CadastrosTemporarios';
import ControleMensagens from './components/admin/ControleMensagens';
import EventoAdicionalPublico from './components/EventoAdicionalPublico';
import EventoPagamentoPublico from './components/EventoPagamentoPublico';
import TermoAutorizacaoPublico from './components/TermoAutorizacaoPublico';
import PagamentoSucesso from './components/PagamentoSucesso';
import PixQrCode from './components/PixQrCode';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/inscricao" element={<Formulario />} />
            <Route path="/pix-qr-code" element={<PixQrCode />} />
            <Route path="/pagamento-sucesso/:registrationId" element={<PagamentoSucesso />} />
            <Route path="/pagamento-sucesso" element={<Navigate to="/inscricao" replace />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route 
              path="/gerenciamento-colonia" 
              element={
                <PrivateRoute>
                  <GerenciamentoColonia />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/relatorios-colonia"
              element={
                <PrivateRoute>
                  <RelatoriosColonia />
                </PrivateRoute>
              }
            />
            <Route
              path="/chamada-rapida"
              element={
                <PrivateRoute>
                  <ChamadaRapida />
                </PrivateRoute>
              }
            />
            {/* Link público para uso na portaria, sem precisar logar no painel. */}
            <Route path="/chamada-publica" element={<ChamadaRapida publico />} />
            {/* Link público para os pais se inscreverem em itens do evento (ex.: bingo, cachorro-quente). */}
            <Route path="/evento" element={<EventoAdicionalPublico />} />
            <Route path="/evento/pagamento/:compraId" element={<EventoPagamentoPublico />} />
            {/* Link público para os pais assinarem o Termo de Autorização e Responsabilidade. */}
            <Route path="/termo" element={<TermoAutorizacaoPublico />} />
            <Route
              path="/cadastros-temporarios" 
              element={
                <PrivateRoute>
                  <CadastrosTemporarios />
                </PrivateRoute>
              } 
            />
            <Route
              path="/controle-mensagens"
              element={
                <PrivateRoute>
                  <ControleMensagens />
                </PrivateRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
